/**
 * @voltxampere/ui — 25-turn multi-turn potentiometer (Sprint 50-8)
 *
 * Vishay 534-series wirewound multi-turn potentiometer (25 turns).
 * Higher precision than 10-turn trim pots; used in lab equipment,
 * audio gain calibration, sensor offset adjustment.
 *
 * Reference: Vishay Spectrol 534 series datasheet (1998).
 *
 * Engine zero-diff invariant honored — schemaType `potentiometer`
 * (Sprint 23 B4).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const potMultiTurn25 = {
    id: "multi-turn-pot-25",
    nameTr: "Multi-Turn Potansiyometre (25-tur, ince ayar)",
    nameEn: "Multi-Turn Potentiometer (25-turn, fine adjustment)",
    shortcut: "P",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "RV",
    defaultValue: "10kΩ",
    schemaType: "potentiometer",
    defaultParams: {
        resistance: 10000,
        wiperPosition: 0.5,
        turnsPerRotation: 25,
        package: "Vishay 534",
        tolerancePercent: 5,
    },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=pot-multi-turn-25.js.map